export default __webpack_public_path__ + "static/media/learning_karier.2020918d.png";